import React from 'react'
import { useDispatch, useStore } from 'react-redux'
import { Switch, Route, Redirect } from 'react-router-dom'
import Landing from './pages/Landing'
import Dashboard from './pages/Dashboard'
import { doSetAuthInfo } from './redux/actions/auth'
import { doSetDomainInfoManually } from './redux/actions/domain'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { trackEmail } from './redux/actions/emailSettings'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const MainRouter = (props) => {
  const store = useStore().getState()
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  if (window.location.search && window.location.search.includes('state') && window.location.search.includes('code')) {
    let code = window.location.search.split("&")[1].split('=')[1]
    if (code) {
      history.push({
        pathname: '/settings/app/emailing',
        state: { code },
      });
    }
  } else if (window?.location?.search.includes("emailMessageId")) {
    let domain = window?.location?.search?.split("&")[1].split('=')[1]
    let emailUUID = window?.location?.search?.split("&domain")[0].split('=')[1]
 
    // dispatch(trackEmail({messageId: emailUUID, toCreate: false, domain: domain})).then((res) => {
    // }).catch(err => {

    // })
  } else if (window?.location?.search && (window?.location?.pathname?.includes('emailDetail') || window?.location?.pathname?.includes('missedCallDetail') || window?.location?.pathname?.includes('rejectedSupplierDetail'))) {
    
  } else if (window?.location?.search && (window?.location?.pathname?.includes('partner-submissions'))) {
    
  } else if (window.location.search && window.location.search !== "" && !window.location.search.includes('voicemailId') && !window.location.search.includes('matchedSupplierId')) {
    const authInfo = JSON?.parse(decodeURI(`${window.location.search.substring(1)}`))
    dispatch(
      doSetDomainInfoManually({
        currentDomain: authInfo.currentDomain,
        subdomain: authInfo.subdomain,
      })
    )
    dispatch(
      doSetAuthInfo({
        user: authInfo.user,
        token: authInfo.token,
      })
    )
    window.location.search.substring(1)
    window.location.search = ""
  }

  return (
    <div className="main">
      <Switch>
        <Redirect
          from='/'
          to='/login'
          exact
        />
        <Route
          path='/landing'
          component={Landing}
        />
        <Route
          path='/'
          component={Dashboard}
        />
      </Switch>
    </div>
  )
}

export default MainRouter